var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSinglegreytick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_737",
    "data-name": "Group 737",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.007,
    height: 8,
    viewBox: "0 0 11.007 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 11.007,
    height: 8,
    fill: "#9f9f9f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3754",
    "data-name": "Path 3754",
    d: "M4.233,5.08a1.624,1.624,0,0,1,.1-.128Q6.616,2.669,8.9.388a1.218,1.218,0,0,1,1.783,1.66q-.038.041-.078.081L5.137,7.6A1.187,1.187,0,0,1,3.8,7.911a1.288,1.288,0,0,1-.436-.289Q1.864,6.144.384,4.652A1.177,1.177,0,0,1,.06,3.409,1.15,1.15,0,0,1,1,2.572,1.176,1.176,0,0,1,2.1,2.92q.958.96,1.914,1.922c.069.069.133.143.221.238",
    transform: "translate(0 0)",
    fill: "#9f9f9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglegreytick);
export default __webpack_public_path__ + "static/media/singlegreytick.474b29e62fbc12beaab64b7cac9e2a79.svg";
export { ForwardRef as ReactComponent };